import styles from "./ProductTag.module.css";
import PropTypes from "prop-types";

/**
 * Element to display an individual tag.
 */
export function ProductTag({ name }) {
  return <span className={styles.tag}>{name}</span>;
}

ProductTag.propTypes = {
  /**
   * Text displayed in tag.
   */
  name: PropTypes.string.isRequired,
};
